export const getValueByPath = (object: any, path: string, separator = '.') => {
  if (!path) return object;

  const properties: any = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev: any, curr: any) => prev?.[curr], object);
};
